<template>
  <div class="inventoryTransfer">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'allotStatus'">
              {{ requestStatusData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/inventoryTransfer.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import status from '@/common/js/status';
  import tableMixins from '@/common/mixins/table.js';
  import { getUserCompanyList } from '@/common/js/util';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'inventoryTransferList',
    data() {
      return {
        load: false,
        img: '/static/img/tips.png',
        query: {
          allotNo: null,
          allotStatus: null,
          allotDateBegin: null,
          allotDateEnd: null,
          allotOutStorage: null,
          allotInStorage: null,
          allotDepartmentNo: null,
          allotCompanyNo: null,
          allotCreateDateBegin: null,
          allotCreateDateEnd: null,
          productName: null,
          searchTableSpec: null,
          nameVoyageLicense: null,
          freightInformation: null,
          businessInboundBatch: null,
          outboundBatch: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        enterprisePropertyList: [], //企业类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        rowData: {}, //被选中的列
        requestStatusData: ['', '已保存', '审批中', '调拨中', '已撤销', '调拨完成', '已冲销'],
        companyList: [],
        allotStatusList: [
          { value: 1, label: '已保存' },
          { value: 2, label: '审批中' },
          { value: 3, label: '调拨中' },
          { value: 4, label: '已撤销' },
          { value: 5, label: '调拨完成' },
          { value: 6, label: '已冲销' },
        ],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'allotNo',
            title: 'inventoryTransfer.search.allotNo',
            visible: true,
          },
          { field: 'allotStatus', title: 'inventoryTransfer.search.allotStatus', visible: true },
          {
            field: 'preAllotBatchNo',
            title: 'inventoryTransfer.search.preAllotBatchNo',
            visible: true,
          },
          {
            field: 'proAllotBatchNo',
            title: 'inventoryTransfer.search.proAllotBatchNo',
            visible: true,
          },
          { field: 'allotDate', title: 'inventoryTransfer.search.allotDate', visible: true },
          {
            field: 'allotOutStorage',
            title: 'inventoryTransfer.search.allotOutStorage',
            visible: true,
          },
          {
            field: 'allotInStorage',
            title: 'inventoryTransfer.search.allotInStorage',
            visible: true,
          },
          // { field: "salesmanName", title: "inventoryTransfer.search.salesmanNo",  visible: true },
          {
            field: 'allotCreatePersonName',
            title: 'inventoryTransfer.search.allotCreatePerson',
            visible: true,
          },
          {
            field: 'allotDepartmentName',
            title: 'inventoryTransfer.search.allotDepartmentName',
            visible: true,
          },
          {
            field: 'allotCompanyName',
            title: 'inventoryTransfer.search.allotCompanyName',
            visible: true,
          },
          { field: 'productName', title: 'inventoryTransfer.search.productName', visible: true },
          {
            field: 'confirmAllotOutAmount',
            title: 'inventoryTransfer.search.confirmAllotOutAmount',
            visible: true,
          },
          {
            field: 'freightInformation',
            title: 'inventoryTransfer.search.freightInformation',
            visible: true,
          },
          {
            field: 'allotCreateDate',
            title: 'inventoryTransfer.search.allotCreateDate',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'allotNo',
            name: this.$t('inventoryTransfer.search.allotNo'),
            type: 'input',
            placeholder: this.$t('inventoryTransfer.search.allotNoPlaceholder'),
          },
          {
            prop: 'allotStatus',
            name: this.$t('inventoryTransfer.search.allotStatus'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('inventoryTransfer.search.allotStatusPlaceholder'),
            options: this.allotStatusList,
          },
          {
            prop: 'allotDateBegin',
            name: this.$t('inventoryTransfer.search.allotDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotDateStartPlaceholder'),
          },
          {
            prop: 'allotDateEnd',
            name: this.$t('inventoryTransfer.search.allotDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotDateEndPlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'allotOutStorage',
            isMultiple: true,
            name: this.$t('inventoryTransfer.search.allotOutStorage'),
            searchType: 'warehouse',
          },
          {
            type: 'searchTableSpec',
            prop: 'allotInStorage',
            isMultiple: true,
            name: this.$t('inventoryTransfer.search.allotInStorage'),
            searchType: 'warehouse',
          },
          // {
          //   type: 'searchTableSpec',
          //   prop: 'salesmanNo',
          //   name: this.$t("inventoryTransfer.search.salesmanNo"),
          //   searchType: 'personnel'
          // },
          {
            prop: 'allotDepartmentNo',
            name: this.$t('inventoryTransfer.search.allotDepartmentName'),
            placeholder: this.$t('inventoryTransfer.search.allotDepartmentNamePlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            filterData: (data) => {
              const departmentList = this.userInfo.userInfo.allDepartmentList.map(
                (v) => v.personDepartmentCode
              );
              const companyList = JSON.parse(this.userInfo.userInfo.companyList).map(
                (v) => v.personCompanyCode
              );
              const filterCompanyData = data.filter((v) => companyList.includes(v.id));
              const filterFun = (list) => {
                if (!list) return list;
                if (list.children && list.children.length) {
                  return list.map((v) => {
                    v.children = filterFun(v.children);
                    return v;
                  });
                } else return list.filter((v) => departmentList.includes(v.id));
              };
              return filterCompanyData.map((v) => {
                v.children = filterFun(v.children);
                return v;
              });
            },
            clearable: false,
          },
          {
            prop: 'allotCompanyNo',
            name: this.$t('inventoryTransfer.search.allotCompanyName'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('inventoryTransfer.search.allotCompanyNamePlaceholder'),
            options: this.companyList,
          },
          {
            prop: 'allotCreateDateBegin',
            name: this.$t('inventoryTransfer.search.allotCreateDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotCreateDateStartPlaceholder'),
          },
          {
            prop: 'allotCreateDateEnd',
            name: this.$t('inventoryTransfer.search.allotCreateDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotCreateDateEndPlaceholder'),
          },
          {
            prop: 'productName',
            name: this.$t('inventoryTransfer.search.productName'),
            type: 'input',
            placeholder: this.$t('inventoryTransfer.search.productNamePlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'allotCreatePerson',
            isMultiple: true,
            name: this.$t('inventoryTransfer.search.allotCreatePerson'),
            searchType: 'personnel',
          },
          {
            prop: 'nameVoyageLicense',
            name: this.$t('inventoryTransfer.search.nameVoyageLicense'),
            type: 'input',
            placeholder: this.$t('inventoryTransfer.search.nameVoyageLicensePlaceholder'),
          },
          {
            prop: 'freightInformation',
            name: this.$t('inventoryTransfer.search.freightInformation'),
            type: 'input',
            placeholder: this.$t('inventoryTransfer.search.freightInformationPlaceholder'),
          },
          {
            // 调拨前批次号
            type: 'searchTableSpec',
            prop: 'businessInboundBatch',
            isMultiple: true,
            name: this.$t('inventoryTransfer.form.good.businessInboundBatchNo'),
            searchType: 'warehouseBatch',
          },
          {
            // 调拨后批次号
            type: 'searchTableSpec',
            prop: 'outboundBatch',
            isMultiple: true,
            name: this.$t('inventoryTransfer.form.good.outboundBatchNo'),
            searchType: 'warehouseBatch',
          },
        ];
      },
      ...mapState({
        inventoryTransferInfo: (state) => state.inventoryTransferInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getCompany();
      this.getButtonList();
      this.getData();
    },
    methods: {
      //获取公司信息
      async getCompany() {
        this.companyList = await getUserCompanyList();
      },
      //获取数据
      getData() {
        this.load = true;
        let query = JSON.parse(JSON.stringify(this.query));
        //const query = this.$refs.siruiSearch.query;
        query.allotOutStorageNo =
          query.allotOutStorage && query.allotOutStorage.length > 0
            ? query.allotOutStorage[0].storageCode
            : null;
        query.allotInStorageNo =
          query.allotInStorage && query.allotInStorage.length > 0
            ? query.allotInStorage[0].storageCode
            : null;
        query.salesmanNo =
          query.salesman && query.salesman.length > 0 ? query.salesman[0].id : null;
        query.allotCreatePersonNo =
          query.allotCreatePerson && query.allotCreatePerson.length > 0
            ? query.allotCreatePerson[0].id
            : null;
        query.businessInboundBatchNo =
          query.businessInboundBatch && query.businessInboundBatch.length > 0
            ? query.businessInboundBatch[0].batchNo
            : null;
        query.outboundBatchNo =
          query.outboundBatch && query.outboundBatch.length > 0
            ? query.outboundBatch[0].batchNo
            : null;
        delete query.allotOutStorage;
        delete query.allotInStorage;
        delete query.allotCreatePerson;
        delete query.businessInboundBatch;
        delete query.outboundBatch;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        }
      },
      //新增
      add() {
        let path = {
          path: '/wareHouse/inventoryTransferAdd',
          name: 'inventoryTransferAdd',
          meta: {
            keepAlive: true,
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/wareHouse/inventoryTransferDetail',
          name: 'inventoryTransferDetail',
          meta: {
            keepAlive: false,
          },
          query: { id: value.row.allotNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
